var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dropdown-item",staticStyle:{"cursor":"pointer"},on:{"click":_vm.cerrarSesion}},[_c('b-icon',{attrs:{"icon":"box-arrow-right"}}),_vm._v(" Cerrar sesión ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }